import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import AlertBox from "../../components/Messages";
import { useSendNewPasswordMutation } from "../../services/API/PasswordAPI";
import BasePage from "../BasePage/BasePage";
import "./NewPassword.scss";

function NewPassword() {
  const { i18n, t } = useTranslation(["newPassword", "translation", "login", "register"]);

  const navigate = useNavigate();
  const [queryParameter, setQueryParameter] = useSearchParams();
  const token = queryParameter.get("token");
  const [sendNewPasswordReqeust, { isLoading }] = useSendNewPasswordMutation();

  const [errMsg, setErrMsg] = useState("");
  const [formState, setFormState] = useState({
    password: "",
    passwordConfirmation: "",
  });

  const handleChange = ({ target: { name, value } }) => {
    return setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoading) {
      return;
    }

    if (formState.password === "" || formState.passwordConfirmation === "") {
      setErrMsg(t("error.missingInpout"));
      return;
    }

    if (formState.password !== formState.passwordConfirmation) {
      setErrMsg(t("error.noMatch"));
      return;
    }

    try {
      const result = await sendNewPasswordReqeust({
        token,
        password: formState.password,
      }).unwrap();

      queryParameter.delete("token");
      setQueryParameter(queryParameter);

      return navigate("/");
    } catch (err) {
      console.error("err", err);

      if (err?.originalStatus === 200) {
        queryParameter.delete("token");
        setQueryParameter(queryParameter);

        return navigate("/");
      }

      if (!err?.status) {
        return setErrMsg(t("error.noServerResponse", { ns: "newPassword" }));
      } else if (err.originalStatus === 400 || err.originalStatus === 403) {
        return setErrMsg(t("error.linkInvalid", { ns: "newPassword" }));
      } else if (err.originalStatus === 410) {
        return setErrMsg(t("error.expiredLink", { ns: "newPassword" }));
      } else {
        return setErrMsg(t("error.generalFailure", { ns: "newPassword" }));
      }
    }
  };

  useEffect(() => {
    setErrMsg("");
  }, [formState]);

  return (
    <BasePage size={7}>
      <div className="p-md-5 mx-md-4">
        <div className="spacer"></div>
        <h1 className="my-5 pb-1 login-headline">{t("title")}</h1>

        <div>{t("text")}</div>

        <FloatingLabel
          className="mb-md-3"
          controlId="InputPassword"
          label={t("labelText.password", {
            ns: "register",
          })}
        >
          <Form.Control
            onChange={handleChange}
            value={formState.password}
            type="password"
            className="custom-Border"
            placeholder={t("labelText.password", {
              ns: "register",
            })}
            name="password"
            required
          />
        </FloatingLabel>

        <FloatingLabel
          className="mb-md-3"
          controlId="InputPasswordConfirmation"
          label={t("labelText.passwordConfirmation", {
            ns: "register",
          })}
        >
          <Form.Control
            onChange={handleChange}
            value={formState.passwordConfirmation}
            type="password"
            className="custom-Border"
            placeholder={t("labelText.passwordConfirmation", {
              ns: "register",
            })}
            name="passwordConfirmation"
            required
          />
        </FloatingLabel>

        <AlertBox show={errMsg !== ""} message={errMsg} />

        <br />
        <div className="pt-md-1 my-md-5 pb-md-1">
          <button className="login-button" type="button" onClick={handleSubmit}>
            <div className="verticallyAligned">
              <div>{t("submitButton")}</div>
              <div style={{ marginLeft: "25px" }}>
                <FontAwesomeIcon color="yellow" icon={faChevronRight} />
              </div>
            </div>
          </button>
        </div>
        <br />
      </div>
    </BasePage>
  );
}

export default NewPassword;
